import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSelectChange} from '@angular/material/select';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'mx-pagination',
  standalone: false,
  templateUrl: './mx-pagination.component.html',
  styleUrls: ['./mx-pagination.component.scss']
})
export class MxPaginationComponent implements AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() pageIndex = 0;
  @Input() pageSize = 10;
  @Input() noPagination = false;
  @Input() dataSource: MatTableDataSource<any>;

  @Input() set updatePaginator(size: number) {
    if (this.paginator) {
      this.paginator.length = size;
      this.paginator.pageIndex = this.pageIndex;
      this.paginator.pageSize = this.pageSize;

      this.paginator._changePageSize(this.paginator.pageSize);
    }
  }

  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() pageSizeChange = new EventEmitter<number>();

  ngAfterViewInit(): void {
    if (!this.noPagination) {
      this.dataSource.paginator = this.paginator;
    }
  };

  pageSizes: Array<number> = [5, 10, 15, 25, 50];

  public onPageSizeChanged = (matSelectChange: MatSelectChange) => {
    this.pageSize = matSelectChange.value;
    this.paginator._changePageSize(this.pageSize);
  };

  protected onPageChanged = (event: PageEvent) => {
    this.pageChange.emit(event);
  };
}
